import React, { useState } from 'react'
import PropTypes from 'prop-types'
import routes from 'src/lib/rails-routes/rails-routes'

import { t } from 'src/lib/i18n-react'
import { Box, Button, Flex } from '@chatterbug/aaron'

import LevelSlider from './subcomponents/LevelSlider/LevelSlider'
import SelfAssessmentSkeleton from './SelfAssessmentSkeleton'

const SelfAssessment = ({ levels, onClick, currentLevel, isSignup }) => {
  const calculateIndex = (arg) => {
    let index = 0
    if (arg) {
      index = levels.findIndex(
        (level) => arg.start === level.start && arg.code === level.code
      )
    }

    return Math.max(index, 0)
  }

  const [currentlySelected, setCurrentlySelected] = useState(
    levels[calculateIndex(currentLevel)]
  )

  const handleChange = (value) => {
    setCurrentlySelected(levels[value])
  }

  const getButtonText = () => {
    if (isSignup) {
      return currentlySelected.start === 'middle'
        ? t('Start in the middle of %{cefrLevel}', {
            cefrLevel: currentlySelected.code,
          })
        : t('Start at %{cefrLevel}', {
            cefrLevel: currentlySelected.code,
          })
    } else {
      return currentlySelected.start === 'middle'
        ? t('Adjust level to the middle of %{cefrLevel}', {
            cefrLevel: currentlySelected.code,
          })
        : t('Adjust level to %{cefrLevel}', {
            cefrLevel: currentlySelected.code,
          })
    }
  }

  return (
    <SelfAssessmentSkeleton
      sliderSection={
        <LevelSlider
          levels={levels}
          selectedLevelIndex={calculateIndex(currentlySelected)}
          onChange={handleChange}
        />
      }
      titleSection={currentlySelected.label}
      explanationSection={currentlySelected.description}
      buttonSection={
        <Flex
          flexDirection={{ _: 'column', tablet: 'row' }}
          justifyContent="center"
        >
          <Box
            width={{ _: '100%', tablet: 'auto' }}
            mr={{ _: 0, tablet: '2x' }}
            mb={{ _: '2x', tablet: 0 }}
          >
            <Button
              type="ctaTheme2"
              fill="solid"
              onClick={() => onClick(currentlySelected)}
              disableWith={t('Saving level selection...')}
              style={{ width: '100%' }}
            >
              {getButtonText()}
            </Button>
          </Box>
          {!isSignup && (
            <Box width={{ _: '100%', tablet: 'auto' }}>
              <Button
                fill="outline"
                onClick={() => (window.location = routes.account_languages())}
                css={`
                  width: 100%;
                `}
              >
                {t('Cancel')}
              </Button>
            </Box>
          )}
        </Flex>
      }
      disclaimerTextSection={
        <Box as="p">
          {t("Don't worry, you can always change your level later")}
        </Box>
      }
    />
  )
}

SelfAssessment.propTypes = {
  levels: PropTypes.array,
  onClick: PropTypes.func,
  currentLevel: PropTypes.shape({
    id: PropTypes.number,
    code: PropTypes.string,
    label: PropTypes.string,
    start: PropTypes.oneOf(['middle', 'start']),
  }),
  isSignup: PropTypes.bool,
}

export default SelfAssessment
